import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

type FormItemLabelProps = {
  label: string;
  helpText?: string;
};

export const FormItemLabel: React.FC<FormItemLabelProps> = ({
  label,
  helpText,
}) => {
  if (!helpText) {
    return <>{label}</>;
  }

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
      }}
    >
      <span>{label}</span>
      <Tooltip title={helpText} placement="top" arrow>
        <InfoOutlinedIcon fontSize="inherit" />
      </Tooltip>
    </span>
  );
};
